// router/index.js
import React from "react";

const routes = [
  {
    path: "/:type?/:subType?",
    breadcrumb: "",
    component: React.lazy(() => import("../views/energyNew")),
  },
];

export default routes;
